export default __webpack_public_path__ + "static/media/P-001.e12fb116.png";